import React from "react";
import { List, Datagrid, TextField, Filter, TextInput } from "react-admin";
import { formatName, parseName } from "util/misc";

const LocationFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput
        label="Location Name"
        source="name"
        format={(v) => formatName(v)}
        parse={(v) => parseName(v)}
        alwaysOn
      />
    </Filter>
  );
};

const LocationList = (props) => (
  <List {...props} bulkActionButtons={false} filters={<LocationFilter />}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="stableId" />
      <TextField source="abbr" />
    </Datagrid>
  </List>
);

export default LocationList;
